// Display formatting helpers. Uncertainty and scale conventions:
// money compacts to $1.2M / $340K; months render as "MAR 1989".

const MONTHS = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

export function monthLabel(monthIndex: number): string {
  const y = 1988 + Math.floor(monthIndex / 12);
  return `${MONTHS[((monthIndex % 12) + 12) % 12]} ${y}`;
}

export function money(x: number): string {
  const sign = x < 0 ? "-" : "";
  const a = Math.abs(x);
  if (a >= 1e9) return `${sign}$${(a / 1e9).toFixed(a >= 1e10 ? 1 : 2)}B`;
  if (a >= 1e6) return `${sign}$${(a / 1e6).toFixed(a >= 1e8 ? 0 : 1)}M`;
  if (a >= 1e3) return `${sign}$${(a / 1e3).toFixed(0)}K`;
  return `${sign}$${a.toFixed(0)}`;
}

export function pct(x: number, digits = 1): string {
  return `${(x * 100).toFixed(digits)}%`;
}

export function num(x: number): string {
  if (Math.abs(x) >= 1e6) return `${(x / 1e6).toFixed(1)}M`;
  if (Math.abs(x) >= 1e4) return `${(x / 1e3).toFixed(0)}K`;
  return x.toLocaleString("en-US", { maximumFractionDigits: 0 });
}
